
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 138826","xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 111256","fill":"#fff","d":"M0 0h16.195v27.146H0z"}})])]),_c('rect',{attrs:{"data-name":"Rectangle 111252","width":"44","height":"44","rx":"12","fill":"#e02924"}}),_c('g',{attrs:{"data-name":"Group 137901"}},[_c('g',{attrs:{"data-name":"Group 137898","clip-path":"url(#a)","fill":"#fff","transform":"translate(13.902 8.428)"}},[_c('path',{attrs:{"data-name":"Path 153547","d":"M8.117 27.145H1.071A.952.952 0 010 26.082c0-3.523-.006-7.046 0-10.568 0-1.276.06-2.552.177-3.824a23 23 0 01.8-4.442 9.823 9.823 0 012.754-4.692A9.048 9.048 0 017.4.608 19.019 19.019 0 0111.507 0a.906.906 0 01.965.906q.007 2.719 0 5.439a.883.883 0 01-.743.861c-.419.072-.844.1-1.258.206a3.26 3.26 0 00-2.247 2.027 11.22 11.22 0 00-.734 3.341 15.6 15.6 0 00-.061.862.908.908 0 00.986 1.024c2.239 0 4.478.009 6.716-.006a.991.991 0 011.069 1.03c-.014 3.509 0 7.018-.007 10.527a.912.912 0 01-1.026.929h-7.05m7.336-12.216v-.041H8.258v.041z"}}),_c('path',{attrs:{"data-name":"Path 153548","d":"M15.452 14.929H8.258v-.041h7.194v.041"}})])])])
          )
        }
      }
    